import React, { useMemo } from 'react';
import { useAppSelector } from 'flow/hooks/useRedux';
import { isEmptyNullOrUndefined } from 'flow/utils';
import { twMerge } from 'tailwind-merge';
import { ChannelKey } from 'flow/types/EntityKeys';

import AgentBadge from 'flow/components/ui-components/AgentBadge';
import {
    makeSelectAgentsLoggedInToChannelCount,
    makeSelectOwnUserIsLoggedInToChannel,
    selectChannelActiveProfileIsAvailable,
} from 'flow/selectors/channel-selectors';

interface Props {
    channelKey: ChannelKey;
    isSelected?: boolean;
}
const AgentsLoggedInToQueueCount = ({ channelKey, isSelected }: Props) => {
    const selectAgentsLoggedInToChannelCount = useMemo(
        makeSelectAgentsLoggedInToChannelCount,
        [],
    );

    const agentsLoggedInToChannelCount = useAppSelector((state) =>
        selectAgentsLoggedInToChannelCount(state, channelKey),
    );

    const selectOwnUserIsLoggedInToChannel = useMemo(
        makeSelectOwnUserIsLoggedInToChannel,
        [],
    );

    const ownUserIsLoggedInToChannel = useAppSelector((state) =>
        selectOwnUserIsLoggedInToChannel(state, channelKey),
    );

    const channelActiveProfileIsAvailable = useAppSelector((state) =>
        selectChannelActiveProfileIsAvailable(state, channelKey),
    );

    if (
        !channelActiveProfileIsAvailable ||
        isEmptyNullOrUndefined(agentsLoggedInToChannelCount)
    )
        return null;

    return (
        <AgentBadge
            loggedIn={ownUserIsLoggedInToChannel}
            className={twMerge(
                isSelected && agentsLoggedInToChannelCount > 0
                    ? 'bg-gray-300'
                    : null,
            )}
        >
            {agentsLoggedInToChannelCount}
        </AgentBadge>
    );
};

export default AgentsLoggedInToQueueCount;
